module.exports = __webpack_public_path__ + "static/media/16UNODC17.285a2dee.jpg";